import { IBasicTableItem } from "../components/Table/BasicTable";
import { CMSImage } from "./CMS/cmsImage";

export class BaseEntity implements IBasicTableItem {
  originalAssetId: string;
  id: string;
  _id: string;
  assetId: string;
  genreId: string;
  mediaId: string;
  externalId: string | null;
  tagId: string;
  name: string;
  adminName: string;
  originalTitle: string;
  channelId: string;
  createdAt: string;
  updatedAt: string;
  type: string;
  images: CMSImage[];

  constructor() {
    this.images = [];
  }

  getDisplayName() {
    return this.name || this.adminName || this.originalTitle || "";
  }
  getUniqueId() {
    return (
      this._id ||
      this.id ||
      this.channelId ||
      this.assetId ||
      this.tagId ||
      this.externalId ||
      this.genreId ||
      this.mediaId
    );
  }

  getType() {
    return this.type || "none";
  }

  getImage() {
    return (
      this.images[0]?.url ||
      "https://upload.wikimedia.org/wikipedia/commons/b/b1/Missing-image-232x150.png" ||
      ""
    );
  }

  get createdDate() {
    return this.createdAt;
  }

  get changedDate() {
    return this.updatedAt;
  }

  get isPublished() {
    return true;
  }
}
